module.exports = __webpack_public_path__ + "static/homeBcg-fc80c1b58ec75bbadcd6912d9d503e82.jpeg";